import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  signinForm: FormGroup;
  authError: string | null = null;

  constructor(public router: Router, private authService: AuthenticationService) {}

  ngOnInit() {
    this.signinForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required)
    });
  }

  async onSignin() {
    if (this.signinForm.invalid) {
      this.authError = 'Please fill out all required fields correctly.';
      return;
    }

    const { email, password } = this.signinForm.value;
    this.authError = null;

    try {
      await this.authService.signIn(email, password);
      this.router.navigate(['/iq/personality']);
    } catch (err: any) {
      console.error('Signin failed:', err);
      this.authError = 'Incorrect email or password. Please try again.';
    }
  }
}
